var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17.0 17.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1080 L0,1080 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72601749,0 C7.05466988,0 7.32109528,0.267808103 7.32109528,0.598166141 C7.32109528,0.904927175 7.09137134,1.15775485 6.79541613,1.19230798 L6.72601749,1.19633228 L1.19013639,1.19616096 L1.19015557,6.73516719 C1.19015557,7.04192823 0.960431629,7.2947559 0.664476426,7.32930903 L0.595077785,7.33333333 C0.28990057,7.33333333 0.038378256,7.10241716 0.00400352346,6.804926 L0,6.73516719 L0,0.598166141 C0,0.291405106 0.229723941,0.0385774328 0.525679144,0.00402430108 L0.595077785,0 L6.72601749,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72601749,0 C7.05466988,0 7.32109528,0.267808103 7.32109528,0.598166141 C7.32109528,0.904927175 7.09137134,1.15775485 6.79541613,1.19230798 L6.72601749,1.19633228 L1.19013639,1.19616096 L1.19015557,6.73516719 C1.19015557,7.04192823 0.960431629,7.2947559 0.664476426,7.32930903 L0.595077785,7.33333333 C0.28990057,7.33333333 0.038378256,7.10241716 0.00400352346,6.804926 L0,6.73516719 L0,0.598166141 C0,0.291405106 0.229723941,0.0385774328 0.525679144,0.00402430108 L0.595077785,0 L6.72601749,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72601749,0 C7.05466988,0 7.32109528,0.267808103 7.32109528,0.598166141 C7.32109528,0.904927175 7.09137134,1.15775485 6.79541613,1.19230798 L6.72601749,1.19633228 L1.19013639,1.19616096 L1.19015557,6.73516719 C1.19015557,7.04192823 0.960431629,7.2947559 0.664476426,7.32930903 L0.595077785,7.33333333 C0.28990057,7.33333333 0.038378256,7.10241716 0.00400352346,6.804926 L0,6.73516719 L0,0.598166141 C0,0.291405106 0.229723941,0.0385774328 0.525679144,0.00402430108 L0.595077785,0 L6.72601749,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72601749,0 C7.05466988,0 7.32109528,0.267808103 7.32109528,0.598166141 C7.32109528,0.904927175 7.09137134,1.15775485 6.79541613,1.19230798 L6.72601749,1.19633228 L1.19013639,1.19616096 L1.19015557,6.73516719 C1.19015557,7.04192823 0.960431629,7.2947559 0.664476426,7.32930903 L0.595077785,7.33333333 C0.28990057,7.33333333 0.038378256,7.10241716 0.00400352346,6.804926 L0,6.73516719 L0,0.598166141 C0,0.291405106 0.229723941,0.0385774328 0.525679144,0.00402430108 L0.595077785,0 L6.72601749,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89907009,0.0987781985 C4.99477605,0.155775451 5.07474996,0.235749366 5.13174721,0.331455318 L9.01657507,6.85459697 C9.2057929,7.17231883 9.1016198,7.58327464 8.78389795,7.77249247 C8.68027166,7.83420664 8.56189989,7.86678468 8.44128876,7.86678468 L0.67163305,7.86678468 C0.301835043,7.86678468 0.00205452783,7.56700417 0.00205452783,7.19720616 C0.00205452783,7.07659503 0.0346325698,6.95822325 0.0963467391,6.85459697 L3.98117459,0.331455318 C4.17039242,0.013733462 4.58134824,-0.090439633 4.89907009,0.0987781985 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160.0 -252.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.5 253.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.07190129305794679 -0.03685760498046875)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.32109528,0 7.32109528,7.33333333 0,7.33333333 0,0",
    stroke: "none",
    fill: "#E27E17"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.07190129305794679 15.96314239501954) scale(1.0 -1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.32109528,0 7.32109528,7.33333333 0,7.33333333 0,0",
    stroke: "none",
    fill: "#E27E17"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.901397492859385 -0.03685760498046875) scale(-1.0 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.32109528,0 7.32109528,7.33333333 0,7.33333333 0,0",
    stroke: "none",
    fill: "#E27E17"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.901397492859385 15.96314239501954) rotate(-180.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.32109528,0 7.32109528,7.33333333 0,7.33333333 0,0",
    stroke: "none",
    fill: "#E27E17"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.358247345327384 3.763024379532873)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.00205452783,0.00438271319 9.11097055,0.00438271319 9.11097055,7.86678468 0.00205452783,7.86678468 0.00205452783,0.00438271319",
    stroke: "none",
    fill: "#E27E17"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeWarning);
export default __webpack_public_path__ + "static/media/tree-warning.fe4bce76d64b04a3e9ffcdde365b5ba6.svg";
export { ForwardRef as ReactComponent };